import * as React from 'react';

// Material-UI
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EmailIcon from '@mui/icons-material/Email';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import LiveHelp from '@mui/icons-material/LiveHelp';
import PanToolIcon from '@mui/icons-material/PanTool';
import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Tooltip from '@mui/material/Tooltip';

import {
  RequestStatusUpdate,
} from '../../global';

interface NightsToolbarProps {
  handleShowEmailForm: () => void;
  handleStatusChange: (action: RequestStatusUpdate) => void;
  membersSelected: number;
  selectedCount: number;
}

const NightsToolbar: React.FC<NightsToolbarProps> = (props) => {

  const [action, setAction] = React.useState<RequestStatusUpdate>(RequestStatusUpdate.Confirm);

  // #region Event handlers

  /*
   * Handle toolbar action change
   */
  const handleActionChanged = (event: React.MouseEvent<HTMLElement>, a: RequestStatusUpdate) => {
    if (a !== null) {
      setAction(a);
    }
  };

  /*
   * Handle passes status change
   */
  const handleStatusChange = () => {
    props.handleStatusChange(action);
  };

  React.useEffect(() => {
    if (props.selectedCount === 0) {
      setAction(RequestStatusUpdate.Confirm);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedCount]);

  // #endregion

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid>
        <ToggleButtonGroup
          disabled={props.selectedCount === 0}
          value={action}
          exclusive
          onChange={handleActionChanged}
        >
          <ToggleButton value={RequestStatusUpdate.Requested}>
            <Tooltip title="Requested">
              <LiveHelp />
            </Tooltip>
          </ToggleButton>
          <ToggleButton value={RequestStatusUpdate.Deny}>
            <Tooltip title="Deny">
              <BlockIcon />
            </Tooltip>
          </ToggleButton>
          <ToggleButton value={RequestStatusUpdate.Waitlist}>
            <Tooltip title="Waitlist">
              <PanToolIcon />
            </Tooltip>
          </ToggleButton>
          <ToggleButton value={RequestStatusUpdate.Confirm}>
            <Tooltip title="Confirmed">
              <CheckCircleIcon />
            </Tooltip>
          </ToggleButton>
        </ToggleButtonGroup>
      </Grid>
      <Grid>
        <Tooltip title="Approve the status change for selected lodge use requests">
          <span>
            <IconButton
              disabled={props.selectedCount === 0}
              onClick={handleStatusChange}
              size="large"
            >
              <PlaylistPlayIcon />
            </IconButton>
          </span>
        </Tooltip>
      </Grid>
      <Grid>
        <Tooltip title="Email selected members">
          <span>
            <IconButton
              disabled={props.membersSelected === 0}
              onClick={props.handleShowEmailForm}
              size="large"
            >
              <EmailIcon />
            </IconButton>
          </span>
        </Tooltip>
      </Grid>
    </Grid >
  );

}

export default NightsToolbar;